module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "max-width": "600px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', [_c('span', {
    staticClass: "heading",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.expense.name))]), (!_vm.expense.optional) ? _c('span', {
    staticClass: "heading ml-2"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "expense-subheading"
  }, [_vm._v(_vm._s(_vm.expense.hint))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-slider', {
    attrs: {
      "max": _vm.expense.max,
      "min": 0,
      "step": 10,
      "thumb-label": ""
    },
    on: {
      "end": _vm.sliderFinished
    },
    model: {
      value: (_vm.expense.value),
      callback: function($$v) {
        _vm.$set(_vm.expense, "value", $$v)
      },
      expression: "expense.value"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "expense-amount",
    staticStyle: {
      "flex": "0 0 110px",
      "text-align": "right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.displayExpense) + "\n        "), _c('v-btn', {
    staticStyle: {
      "width": "25px",
      "height": "25px"
    },
    attrs: {
      "fab": "",
      "small": "",
      "dark": "",
      "color": "grey lighten-1",
      "icon": ""
    },
    on: {
      "click": _vm.showDetails
    }
  }, [_c('v-icon', [_vm._v("more_horiz")])], 1)], 1)]), _vm._v(" "), ((!_vm.isInRange) && _vm.hasValue) ? _c('div', {
    staticStyle: {
      "max-width": "500px"
    }
  }, [(_vm.rangeError) ? _c('div', {
    staticClass: "pa-2 no-print grey--text text--darken-1"
  }, [_c('v-icon', {
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "color": "red lighten-2"
    }
  }, [_vm._v("report_problem")]), _vm._v(" "), (_vm.expense.name == 'Other') ? _c('span', [_vm._v("Please give specifics")]) : _c('span', [_vm._v("This is " + _vm._s(_vm.higherOrLower) + " than expected, Your lender will require an explanation why.")])], 1) : _vm._e(), _vm._v(" "), _c('v-textarea', {
    staticClass: "no-print mt-2",
    attrs: {
      "outline": "",
      "label": "",
      "single-line": "",
      "rows": 2
    },
    model: {
      value: (_vm.expense.explanation),
      callback: function($$v) {
        _vm.$set(_vm.expense, "explanation", $$v)
      },
      expression: "expense.explanation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "print-only"
  }, [_vm._v("Client comment: " + _vm._s(_vm.expense.explanation))])], 1) : _vm._e(), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "settings": _vm.breakdownDialog.settings
    },
    on: {
      "save": _vm.saveBreakdown
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "inset-text mb-3"
  }, [_c('span', {
    staticStyle: {
      "background-color": "yellow"
    }
  }, [_vm._v("Optional.")]), _vm._v(" You can use the categories below to work out your " + _vm._s(_vm.expense.name) + " expense in more detail.\n        ")]), _vm._v(" "), _vm._l((_vm.expense.breakdown), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "pa-2",
      staticStyle: {
        "display": "flex",
        "width": "100%",
        "font-size": "16px"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1 0 0"
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-basis": "150px"
      }
    }, [_vm._v("\n                $ "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "expense-box show-border",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "value", $event.target.value)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.breakdownTotal) ? _c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "font-size": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1 0 0"
    }
  }, [_vm._v("\n                Total\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-basis": "150px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(this.breakdownTotal)) + "\n            ")])]) : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f7a10cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LivingExpenses/LivingExpense.vue
// module id = 2520
// module chunks = 1